import { Routes } from '@angular/router';
import { authGuard, guestGuard } from '@core/guards';

export const routes: Routes = [
  { path: '', loadChildren: () => import('./shell/shell.routes').then(m => m.shellRoutes), canActivate: [authGuard] },
  { path: 'login', loadComponent: () => import('./routes/login/login.component').then(m => m.LoginComponent), canActivate: [guestGuard] },
  { path: 'device-not-enrolled', loadComponent: () => import('./routes/device-not-enrolled/device-not-enrolled.component').then(m => m.DeviceNotEnrolledComponent) },
  { path: 'enroll/:token', loadComponent: () => import('./routes/enroll/enroll.component').then(m => m.EnrollComponent) },
  { path: 'enroll', loadComponent: () => import('./routes/enroll/enroll.component').then(m => m.EnrollComponent) },
  { path: '**', redirectTo: '/' },
];